export const environment = {
  Server_URL: 'https://backendtest.blueboxpet.com/api'
    //  Server_URL: 'https://backendproduction.blueboxpet.com/api',
};
